import { Box, Circle, Image, Text, CircularProgress } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { myActivityReset, setAutocompleteVisibility, setHeaderText, setSelectedMenuItem } from "../../redux/actions/action";
import { loadLeadershipBoard, loadLiveCourses, loadMyActivity } from "../../redux/api/apiCalls";
import Announcements from "../common/Announcements";
import IncourseStatics from "./IncourseStatics";
import IndividualLeadershipBoardCard from "./IndividualLeadershipBoardCard";
import ProgressComponent from "./ProgressComponent";
import Statistics from "./Statistics";
import UpcomingClasses from "./UpcomingClasses";


export default function Home() {
    const { leadershipBoardData, isLoading, leadershipBoardError } = useSelector(state => state.leadershipBoardState)
    const { myActivityData, isLoading: myActivityIsLoading } = useSelector(state => state.myActivityState)
    const [alert, setAlert] = useState(null)
    const headerText = useSelector(state => state.headerState.headerText)
    const [userName, setUserName] = useState('John')
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setSelectedMenuItem(0))
        dispatch(loadLeadershipBoard())
        dispatch(loadMyActivity())
        dispatch(loadLiveCourses())
        return () => dispatch(myActivityReset())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user) {
            setUserName(user.payload.first_name[0].toUpperCase() + user.payload.first_name.substring(1))
        }
    }, [])

    useEffect(() => {
        let date = new Date(Date.now())
        let month = (Number(date.getMonth()) + 1)
        let day = date.getDate()
        let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
        if (!myActivityIsLoading && myActivityData.length) {
            let filteredActivity = myActivityData.filter(activity => Date.parse(activity.date) >= Date.parse(today)).sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
            if(filteredActivity.length){
                let alertFilter = filteredActivity.filter(activity => ['E','F','S'].includes(activity.status))
                if(alertFilter.length){
                    filteredActivity = alertFilter.map(activity => activity)
                }
            }
            setAlert(filteredActivity.length ? filteredActivity[0] : [])
        }
    }, [myActivityData, myActivityIsLoading])


    useEffect(() => {
        dispatch(setHeaderText(`Welcome, ${userName}!`))
        // eslint-disable-next-line
    }, [userName])

    return (
        <Box
            px='1rem'
            w='95%'
            minH='90vh'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >

            <Box width='100%' justifyContent={['flex-end', 'flex-end', 'flex-end', 'flex-end', 'space-between']} alignItems='center' d='flex' mb='2rem' pt='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
                {
                    alert &&
                    <Box
                        border='1px solid #FF7251'
                        boxShadow='0px 2px 20px rgba(0, 0, 0, 0.1)'
                        borderRadius='10px'
                        bg='#ffffff'
                        d='flex'
                        justifyContent='flex-start'
                        py='0.5rem'
                        px='1rem'
                        alignItems='center'
                    >
                        {
                            alert.status === 'E' &&
                            <Circle
                                size='10px'
                                bg='#ff7251'
                                mr='0.5rem'
                            ></Circle>
                        }
                        <Text
                            fontSize='14px'
                            color='#666666'
                            fontWeight='600'
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                        >
                            {alert.description}
                        </Text>
                    </Box>
                }
            </Box>

            <Box
                width='100%'
                d='flex'
                justifyContent='space-between'
                mb='1.5rem'
            >
                <Box
                    w='27.5%'
                    d='flex'
                    flexDir='column'
                >
                    <Text
                        fontSize='15px'
                        color='#222222'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                    >
                        LEADERSHIP BOARD
                    </Text>

                    <Box
                        w='100%'
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius='10px'
                        boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                        pt='1rem'
                        bg='#ffffff'
                        height='560px'
                        overflowX='auto'
                        sx={{
                            '&::-webkit-scrollbar': {
                                width: '5px',
                                borderRadius: '8px',
                                backgroundColor: `transparent`,
                                height: '90%',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: `rgba(0, 0, 0,0.2)`,
                                borderRadius: '20px'
                            },
                        }}
                    >
                        <Box
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1.25rem'
                            px='1rem'
                        // pr='0.5rem'
                        >
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%'>RANK</Text>
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='65%' textAlign='start'>EMPLOYEE</Text>
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>SCORE</Text>
                        </Box>
                        {
                            isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='0.5rem'>
                                <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                            </Box> :
                                !isLoading && leadershipBoardData.length > 0 ?
                                    leadershipBoardData.map((employee, idx) => <IndividualLeadershipBoardCard employee={employee} id={idx} key={idx} />) :
                                    <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                                        <Text
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            fontSize='20px'
                                            fontWeight='600'
                                            color='#222222'
                                            mb='1rem'
                                        >
                                            {leadershipBoardError && 'Something went wrong!'}
                                        </Text>
                                    </Box>}
                    </Box>
                </Box>
                <Box
                    d='flex'
                    width='32%'
                    flexDir='column'
                    justifyContent='space-between'
                >
                    <UpcomingClasses />
                    <ProgressComponent />
                </Box>
                <Box
                    d='flex'
                    width='32%'
                    height='inherit'
                >
                    <Announcements dashboard={true} />
                </Box>
            </Box>


            <Statistics />
            <IncourseStatics />

            <Box
                width='100%'
                d='flex'
                justifyContent='space-between'
                flexDir='column'
            >
                <Text
                    fontSize='15px'
                    color='#222222'
                    fontWeight='800'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    mb='1rem'
                >
                    OVERALL PERFORMANCE
                </Text>
                <Box
                    w='100%'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    pt='1rem'
                    bg='#ffffff'
                    mb='1rem'
                >
                    <Image src='./images/learner-graph.jpg' alt='Graph' objectFit='cover' width='100%' height='100%' borderRadius='10px' />
                </Box>

            </Box>

        </Box >
    )
}